import { createGlobalStyle } from "styled-components";


const Variables = createGlobalStyle`

  :root {

    //!Screen Sizes
    --DesktopSize: ${props => props.theme.mediaQuery.DesktopSize};
    --LaptopSize: ${props => props.theme.mediaQuery.LaptopSize};
    --TabletSize: ${props => props.theme.mediaQuery.TabletSize};
    --TabletSizeS: ${props => props.theme.mediaQuery.TabletSizeS};
    --MobileSize: ${props => props.theme.mediaQuery.MobileSize};

    //!Colors
    --black: ${props => props.theme.colors.black};
    --white: ${props => props.theme.colors.white};
    --green: ${props => props.theme.colors.green};
    --purple: ${props => props.theme.colors.purple};
    --red: ${props => props.theme.colors.red};
    --orange: ${props => props.theme.colors.orange};
    --grey: ${props => props.theme.colors.grey};
    --darkGrey: ${props => props.theme.colors.darkGrey};
    --lightGrey: ${props => props.theme.colors.lightGrey};
    --lightYellow: ${props => props.theme.colors.lightYellow};
    --lightPurple: ${props => props.theme.colors.lightPurple};
    --lightBlue: ${props => props.theme.colors.lightBlue};


    //! Error color
    --errorColor: ${(props) => props.theme.colors.errorColor};

    //! Spacing
    --spSize: 8px;

    --sp0-5x: calc(var(--spSize) * 0.5);
    --sp0-75x: calc(var(--spSize) * 0.75);
    --sp1x: calc(var(--spSize));
    --sp1-3x: calc(var(--spSize) * 1.3);
    --sp1-25x: calc(var(--spSize) * 1.25);
    --sp1-5x: calc(var(--spSize) * 1.5);
    --sp1-6x: calc(var(--spSize) * 1.7);
    --sp1-75x: calc(var(--spSize) * 1.75);
    --sp2x: calc(var(--spSize) * 2);
    --sp2-5x: calc(var(--spSize) * 2.5);
    --sp3x: calc(var(--spSize) * 3);
    --sp3-5x: calc(var(--spSize) * 3.5);
    --sp4x: calc(var(--spSize) * 4);
    --sp4-5x: calc(var(--spSize) * 4.5);
    --sp5x: calc(var(--spSize) * 5);
    --sp5-5x: calc(var(--spSize) * 5.5);
    --sp6x: calc(var(--spSize) * 6);
    --sp6-5x: calc(var(--spSize) * 6.5);
    --sp7x: calc(var(--spSize) * 7);
    --sp7-5x: calc(var(--spSize) * 7.5);
    --sp8x: calc(var(--spSize) * 8);
    --sp8-5x: calc(var(--spSize) * 8.5);
    --sp9x: calc(var(--spSize) * 9);
    --sp9-5x: calc(var(--spSize) * 9.5);
    --sp10x: calc(var(--spSize) * 10);
    --sp11x: calc(var(--spSize) * 11);
    --sp12x: calc(var(--spSize) * 12);
    --sp13x: calc(var(--spSize) * 13);
    --sp14x: calc(var(--spSize) * 14);
    --sp14-5x: calc(var(--spSize) * 14.5);
    --sp15x: calc(var(--spSize) * 15);
    --sp16x: calc(var(--spSize) * 16);
    --sp17x: calc(var(--spSize) * 17);
    --sp18x: calc(var(--spSize) * 18);
    --sp18-5x: calc(var(--spSize) * 18.5);
    --sp19x: calc(var(--spSize) * 19);
    --sp20x: calc(var(--spSize) * 20);
    --sp20-5x: calc(var(--spSize) * 20.5);
    --sp21x: calc(var(--spSize) * 21);
    --sp22x: calc(var(--spSize) * 22);
    --sp23x: calc(var(--spSize) * 23);
    --sp24x: calc(var(--spSize) * 24);
    --sp25x: calc(var(--spSize) * 25);
    --sp26x: calc(var(--spSize) * 26);
    --sp27x: calc(var(--spSize) * 27);
    --sp28x: calc(var(--spSize) * 28);
    --sp29x: calc(var(--spSize) * 29);
    --sp30x: calc(var(--spSize) * 30);
    --sp31x: calc(var(--spSize) * 31);
    --sp32x: calc(var(--spSize) * 32);
    --sp33x: calc(var(--spSize) * 33);
    --sp34x: calc(var(--spSize) * 34);
    --sp36x: calc(var(--spSize) * 36);
    --sp37x: calc(var(--spSize) * 37);
    --sp38x: calc(var(--spSize) * 38);
    --sp39x: calc(var(--spSize) * 39);
    --sp40x: calc(var(--spSize) * 40);
    --sp41x: calc(var(--spSize) * 41);
    --sp41-5x: calc(var(--spSize) * 41.5);
    --sp42x: calc(var(--spSize) * 42);
    --sp42-5x: calc(var(--spSize) * 42.5);
    --sp43x: calc(var(--spSize) * 43);
    --sp44x: calc(var(--spSize) * 44);
    --sp45x: calc(var(--spSize) * 45);
    --sp46x: calc(var(--spSize) * 46);
    --sp47x: calc(var(--spSize) * 47);
    --sp48x: calc(var(--spSize) * 48);
    --sp49x: calc(var(--spSize) * 49);
    --sp50x: calc(var(--spSize) * 50);
    --sp51x: calc(var(--spSize) * 51);
    --sp52x: calc(var(--spSize) * 52);
    --sp53x: calc(var(--spSize) * 53);
    --sp54x: calc(var(--spSize) * 54);
    --sp55x: calc(var(--spSize) * 55);
    --sp56x: calc(var(--spSize) * 56);
    --sp57x: calc(var(--spSize) * 57);
    --sp57-5x: calc(var(--spSize) * 57.5);
    --sp58x: calc(var(--spSize) * 58);
    --sp59x: calc(var(--spSize) * 59);
    --sp60x: calc(var(--spSize) * 60);
    --sp63x: calc(var(--spSize) * 63);
    --sp64x: calc(var(--spSize) * 64);
    --sp66x: calc(var(--spSize) * 66);
    --sp67x: calc(var(--spSize) * 67);
    --sp68x: calc(var(--spSize) * 68);
    --sp68-5x: calc(var(--spSize) * 68.5);
    --sp69x: calc(var(--spSize) * 69);
    --sp70x: calc(var(--spSize) * 70);
    --sp71x: calc(var(--spSize) * 71);
    --sp72x: calc(var(--spSize) * 72);
    --sp72-5x: calc(var(--spSize) * 72.5);
    --sp73x: calc(var(--spSize) * 73);
    --sp75x: calc(var(--spSize) * 75);
    --sp76x: calc(var(--spSize) * 76);
    --sp77x: calc(var(--spSize) * 77);
    --sp78x: calc(var(--spSize) * 78);
    --sp80x: calc(var(--spSize) * 80);
    --sp81x: calc(var(--spSize) * 81);
    --sp81-5x: calc(var(--spSize) * 81.5);
    --sp82x: calc(var(--spSize) * 82);
    --sp83x: calc(var(--spSize) * 83);
    --sp84x: calc(var(--spSize) * 84);
    --sp85x: calc(var(--spSize) * 85);
    --sp85-5x: calc(var(--spSize) * 85.5);
    --sp88x: calc(var(--spSize) * 88);
    --sp89x: calc(var(--spSize) * 89);
    --sp91x: calc(var(--spSize) * 91);
    --sp93x: calc(var(--spSize) * 93);
    --sp94x: calc(var(--spSize) * 94);
    --sp97x: calc(var(--spSize) * 97);
    --sp98x: calc(var(--spSize) * 98);
    --sp99x: calc(var(--spSize) * 99);
    --sp100x: calc(var(--spSize) * 100);
    --sp103x: calc(var(--spSize) * 103);
    --sp106x: calc(var(--spSize) * 106);
    --sp108x: calc(var(--spSize) * 108);
    --sp111x: calc(var(--spSize) * 111);
    --sp112x: calc(var(--spSize) * 112);
    --sp115x: calc(var(--spSize) * 115);
    --sp116x: calc(var(--spSize) * 116);
    --sp117x: calc(var(--spSize) * 117);
    --sp118x: calc(var(--spSize) * 118);
    --sp128x: calc(var(--spSize) * 128);
    --sp122x: calc(var(--spSize) * 122);
    --sp123x: calc(var(--spSize) * 123);
    --sp132x: calc(var(--spSize) * 132);
    --sp134x: calc(var(--spSize) * 134);
    --sp136x: calc(var(--spSize) * 136);
    --sp141x: calc(var(--spSize) * 141);
    --sp142x: calc(var(--spSize) * 142);
    --sp148x: calc(var(--spSize) * 148);
    --sp150x: calc(var(--spSize) * 150);
    --sp152x: calc(var(--spSize) * 152);
    --sp166x: calc(var(--spSize) * 166);
    --sp180x: calc(var(--spSize) * 180);
    --sp184x: calc(var(--spSize) * 184);
    --sp190x: calc(var(--spSize) * 190);
    --sp270x: calc(var(--spSize) * 270);

    //! Transition
    //! Transition time
    --trTime: 0.3s;
    --trTime2: 0.5s;
    --trTime3: 0.7s;

    --transitionTime: var(--trTime);
    --transitionTime2: var(--trTime2);
    --transitionTime3: var(--trTime3);

    //line heights
    --lineHeight: 1.5;
    --lineHeightS: 1.2;
    --lineHeightXS: 1;

    --h1: 64px;
    --h2: 36px;
    --h3: 24px;
    --h4: 18px;
    --h5: 16px;
    --h6: 14px;
    --h7: 13px;
    --h8: 12px;
    --p: 11px;

    //development period new font sizes that not in ui kit
    --h9: 20px;
    --const14: 14px;
    --h10: 48px;
    --h11: 24px;
    --h12: 20px;
    --h13: 48px;

    --inputTextPadding: var(--sp2x) var(--sp3x);

    //! Container
    --containerPadding: var(--sp8x);

    //! Title margin
    --titleMarginBottom: var(--sp8x);
    --subtitleMarginBottom: var(--sp4x);
    --sectionMarginBottom: var(--sp20x);

  }

  @media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
    :root {
      //! Container
      --containerPadding: var(--sp2x);

      //! Title margin
      --titleMarginBottom: var(--sp2x);
      --subtitleMarginBottom: var(--sp3x);
      --sectionMarginBottom: var(--sp10x);

      --h1: 32px;
      --h2: 20px;
      --h3: 16px;
      --h4: 15px;
      --h5: 14px;
      --h6: 12px;
      --h7: 12px;
      --h8: 12px;
      --p: 11px;

      //! Development period new font sizes that not in ui kit
      --h9: 16px;
      --h10: 24px;
      --h11: 18px;
      --h12: 14px;
      --h13: 30px;
    }
  }
`

export default Variables